import { render, staticRenderFns } from "./DoctorsDetail.vue?vue&type=template&id=1c952cdc&scoped=true&"
import script from "./DoctorsDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DoctorsDetail.vue?vue&type=style&index=1&id=1c952cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c952cdc",
  null
  
)

export default component.exports